import { cn } from "../lib/utils";

export default function OAButton({ children, className, variant = "fill", theme = "primary", ...props }) {
  const variants = {
    fill: {
      primary: "bg-oaRed text-white hover:bg-oaRed/75 disabled:bg-oaRed/75",
      secondary: "bg-oaBackgroundText hover:bg-oaBackgroundText/75 text-oaForegroundText",
    },
    outline: {
      primary: "bg-transparent border-2 border-oaRed hover:bg-oaRed/20 text-oaRed",
      secondary: "bg-transparent border-2 border-oaBackgroundText hover:bg-oaBackgroundText/40 text-oaForegroundText",
    },
  };

  return (
    <button
      className={cn(
        `h-7 lg:h-8 flex justify-center items-center text-[10px] lg:text-[12px] font-semibold px-3 rounded-[4px] antialiased transition-all duration-300`,
        variants[variant][theme],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
